<template>
<section class="py-16">
  <div class="container mx-auto px-6">
    <div class="text-center mb-12">
      <h2 class="text-3xl font-bold text-gray-800 mb-2">作品商城</h2>
      <p class="text-gray-600">发现独特创意，选购心仪作品</p>
    </div>
    <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
      <ProductCard v-for="(showcase, index) in showcases.slice(0, 10)" :key="index" :product="showcase" />
    </div>
    <div class="text-center mt-10">
      <router-link to="/mall" class="bg-white border-2 border-[#76B900] text-[#76B900] hover:bg-[#76B900] hover:text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-300 !rounded-button whitespace-nowrap cursor-pointer">
        查看更多作品
      </router-link>
    </div>
  </div>
</section>
</template>

<script>
import ProductCard from '@/components/common/ProductCard.vue';
export default {
  name: 'ShowcaseSection',
  components: { ProductCard },
  props: {
    showcases: {
      type: Array,
      required: true
    }
  },

  mounted() {
    // console.log(this.showcases)
  }
}
</script> 